import { Component, OnInit } from '@angular/core';
import {SellerDashboardService} from './seller-dashboard.service';
import { Response } from '@angular/http';
import {Device} from '../../entities/device/device.model';

@Component( {
    selector: 'dcs-seller-chart',
    templateUrl: './seller-chart.component.html',
    styles: []
} )
export class SellerChartComponent implements OnInit {
    devices: Device[];
    activeDevices: number = 0;
    activeDevicesPerc: number = 0;
    allDevices: number;


    constructor(private sellerService: SellerDashboardService) {
    }

    ngOnInit() {
        this.sellerService.loadDevices().subscribe( (res: Response) => {
            this.devices = res.json();
            this.allDevices = this.devices.length;
            for (let device of this.devices) {
                if (device.activated === true)
                    this.activeDevices += 1;
            }
            this.activeDevicesPerc = Math.round( this.activeDevices / this.allDevices * 100 );

        } )
    }

    getStyle() {
        return `${this.activeDevicesPerc}%`
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/dashboard/seller-dashboard/seller-chart.component.ts